import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware, { END } from "redux-saga";

import rootReducer from "./modules/rootReducer";

function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(sagaMiddleware)
  );

  if (module.hot) {
    module.hot.accept("./modules/rootReducer", () =>
      store.replaceReducer(require("./modules/rootReducer").default)
    );
  }

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);

  return store;
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/createStore.js